import React from "react";

import Image from "next/image";

import AccuracyImage from "public/images/icons/icon-enerflo-docflo-document-accuracy.svg";
import ChangeOrdersImage from "public/images/icons/icon-enerflo-docflo-document-change-orders.svg";
import SecurityImage from "public/images/icons/icon-enerflo-docflo-document-security-compliance.svg";
import TimingImage from "public/images/icons/icon-enerflo-docflo-document-timing.svg";

import HeroSection from "../../../hero-section";
import Card from "./card";

const cards = {
  accuracy: {
    title: "Accuracy, Every Time",
    description:
      "Lucky for you, our team of Doc nerds love to place automation on top of your contracts. Need a calculation to occur? Only want specific adders to show up? Need an AC/DC conversion calculated? It’s easy with Enerflo. Your contracts are all onboarded, eliminating the need for manual packet creation or calling Betty in your back office to send them via DocuSign. Our doc engine gives your reps the ability to build them in seconds, allowing them to quickly and accurately close deals.",
    figure: <Image src={AccuracyImage} alt="Icon - Enerflo Docflo Accuracy." />,
  },
  changeOrders: {
    title: "Change Orders Redefined",
    description:
      "Change orders happen. You may discover a MPU is needed, or maybe you ran out of the panel the customer signed up for. It’s the nature of the business. Docflo makes change orders as painless as possible, making it easy for the sales rep or your ops team to quickly make modifications to the project. Enerflo organizes everything and keeps track of the history so you don't have to.",
    figure: <Image src={ChangeOrdersImage} alt="Icon - Enerflo Docflo Change Orders." />,
  },
  security: {
    title: "Security and Compliance",
    description:
      "Docflo is eSign compliant. It tracks the IP address of signers, the device being used, the delivery method and more. Documents are sent securely and stored in a secure location on the AWS cloud. We’ll store them forever until you remove them. And no, we don’t charge for storage, because this isn’t 1990.",
    figure: <Image src={SecurityImage} alt="Icon - Enerflo Docflo Security Compliance." />,
  },
  timing: {
    title: "Every Second Counts",
    description:
      "Close customers while they are engaged. Docflo creates the average document packet in under 3 seconds… (the time it took you to read that sentence). With that speed, your reps can carry the momentum of the sale. Plus, our in-person signing feature allows customers to sign quickly on the spot. Can’t be in person, or selling over the phone? With Docflo, you can easily send a secured signing link via text or email to your customer.",
    figure: <Image src={TimingImage} alt="Icon - Enerflo Docflo Every Second Counts." />,
  },
};

const DetailsGrid = () => (
  <div className="relative flex-grow bg-gradient-to-br from-primary to-navy-dark">
    <HeroSection className="px-6">
      <div className="mx-auto relative z-[1] sm:max-w-[90%] xl:max-w-[75%]">
        <div className="grid grid-cols-1 items-stretch gap-6 md:grid-cols-2">
          <Card {...cards.accuracy} />
          <Card {...cards.changeOrders} />
          <Card {...cards.security} />
          <Card {...cards.timing} />
        </div>
      </div>
    </HeroSection>
  </div>
);

export default DetailsGrid;
